/* eslint-disable no-unused-vars, no-param-reassign */

const initialState = {
  savedSelectedFundsList: [],
};

const actions = {
  saveSelectedFundsList: {
    root: true,
    handler({ commit }, selectedFundsList) {
      commit('saveSelectedFundsList', selectedFundsList);
    },
  },
  saveOriginalFundsList: {
    root: true,
    handler({ commit }, selectedFundsList) {
      commit('saveOriginalFundsList', selectedFundsList);
    },
  },
  saveRemovedFundsList: {
    root: true,
    handler({ commit }, selectedFundsList) {
      commit('saveRemovedFundsList', selectedFundsList);
    },
  },
  cleanSelectedFundsList: {
    root: true,
    handler({ commit }) {
      commit('cleanSelectedFundsList');
    },
  },
};

const mutations = {
  saveSelectedFundsList(state, selectedFundsList) {
    state.savedSelectedFundsList = selectedFundsList;
  },
  saveOriginalFundsList(state, selectedFundsList) {
    state.savedOriginalFundsList = selectedFundsList;
  },
  saveRemovedFundsList(state, selectedFundsList) {
    state.savedRemovedFundsList = selectedFundsList;
  },
  cleanSelectedFundsList(state) {
    state.savedSelectedFundsList = [];
    state.savedOriginalFundsList = [];
    state.savedRemovedFundsList = [];
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
